<template>
  <div>
    <div
      v-if="fixedTitle && title != '' && !noTitleShow"
      class="_space_12o8q_1 _row-md_12o8q_37 _section-header_f3txd_1 justify-start"
      style="margin-bottom: 1rem"
    >
      <h3>{{ title }}</h3>
    </div>
    <ul
      :id="'infinite-list-' + uuid"
      :style="
        'width: 100%; ' +
        [
          fixedHeight != null
            ? 'overflow: auto; height: ' + fixedHeight + ';'
            : [maxHeight != null ? 'overflow: auto; max-height: ' + maxHeight + ';' : '']
        ]
      "
    >
      <div
        v-if="!fixedTitle && title != '' && !noTitleShow"
        class="_space_12o8q_1 _row-md_12o8q_37 _section-header_f3txd_1 justify-start"
        style="margin-bottom: 1rem"
      >
        <h3>{{ title }}</h3>
      </div>
      <div v-if="length == 0 && !loading" class="_empty_r82f5_1">
        <span class="_icon_r82f5_11"
          ><svg
            class="svg-component"
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clip-rule="evenodd"
              d="M3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25H4.25V19.4656C4.25 20.9186 5.91841 21.7387 7.06891 20.8512L8.39974 19.8246C8.48344 19.76 8.59871 19.7551 8.68763 19.8122L10.5129 20.9856C11.4188 21.568 12.5812 21.568 13.4871 20.9856L15.3124 19.8122C15.4013 19.7551 15.5166 19.76 15.6003 19.8246L16.9311 20.8512C18.0816 21.7387 19.75 20.9186 19.75 19.4656V4.25H21C21.4142 4.25 21.75 3.91421 21.75 3.5C21.75 3.08579 21.4142 2.75 21 2.75H3ZM8.25 9.5C8.25 9.08579 8.58579 8.75 9 8.75H12C12.4142 8.75 12.75 9.08579 12.75 9.5C12.75 9.91421 12.4142 10.25 12 10.25H9C8.58579 10.25 8.25 9.91421 8.25 9.5ZM9 12.75C8.58579 12.75 8.25 13.0858 8.25 13.5C8.25 13.9142 8.58579 14.25 9 14.25H12C12.4142 14.25 12.75 13.9142 12.75 13.5C12.75 13.0858 12.4142 12.75 12 12.75H9ZM14.25 9.5C14.25 9.08579 14.5858 8.75 15 8.75H15.5C15.9142 8.75 16.25 9.08579 16.25 9.5C16.25 9.91421 15.9142 10.25 15.5 10.25H15C14.5858 10.25 14.25 9.91421 14.25 9.5ZM15 12.75C14.5858 12.75 14.25 13.0858 14.25 13.5C14.25 13.9142 14.5858 14.25 15 14.25H15.5C15.9142 14.25 16.25 13.9142 16.25 13.5C16.25 13.0858 15.9142 12.75 15.5 12.75H15Z"
              fill="currentColor"
              fill-rule="evenodd"
              opacity="0.3"
            ></path>
            <path
              clip-rule="evenodd"
              d="M3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25H4.25H19.75H21C21.4142 4.25 21.75 3.91421 21.75 3.5C21.75 3.08579 21.4142 2.75 21 2.75H3Z"
              fill="currentColor"
              fill-rule="evenodd"
            ></path></svg></span
        ><span>{{ emptyTitle }}</span>
      </div>
      <div :class="[noSpace ? '_card_hl826_1' : '_space_12o8q_1 _col-sm_12o8q_5']">
        <div :class="[noSpace ? '_assets_12jgw_1' : '_space_12o8q_1 _col-md_12o8q_12']">
          <li v-for="(_, index) in length" :key="index">
            <slot :name="index" />
          </li>
        </div>
      </div>
      <Loading v-if="loading" />
    </ul>
  </div>
</template>

<script>
import Loading from './Loading.vue'

export default {
  components: {
    Loading
  },
  data() {
    return {
      listener: null,
      uuid: null
    }
  },
  created() {
    this.uuid = this.$filters.generateUUID()
  },
  mounted() {
    this.setScrollListener()
  },
  props: {
    title: {
      default: ''
    },
    emptyTitle: {
      default: ''
    },
    length: {
      required: 0
    },
    loading: {
      default: false
    },
    finished: {
      default: false
    },
    noTitleShow: {
      default: false
    },
    fixedTitle: {
      default: false
    },
    fixedHeight: {
      default: null
    },
    maxHeight: {
      default: null
    },
    noSpace: {
      default: false
    }
  },
  emits: ['loadMore'],
  methods: {
    getListElement() {
      if (this.fixedHeight != null || this.maxHeight != null)
        return document.getElementById('infinite-list-' + this.uuid)
      return document.documentElement
    },
    setScrollListener() {
      var listElm = this.getListElement()
      if (listElm == document.documentElement) listElm = window
      this.listener = listElm.addEventListener('scroll', this.checkForLoad, { passive: true })
    },
    checkForLoad(event) {
      const listElm = this.getListElement()
      if (listElm == undefined) return
      if (listElm.scrollHeight - listElm.scrollTop <= listElm.clientHeight + 100) {
        this.loadMore()
      }
    },
    loadMore() {
      if (this.finished && this.listener != null) {
        document
          .getElementById('infinite-list-' + this.uuid)
          .removeEventListener('scroll', this.checkForLoad)
        this.listener = null
      }
      if (this.loading || this.finished) return
      this.$emit('loadMore')
    }
  }
}
</script>
